// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"f24ede1c","303":"b7831ac2","639":"d598b176","665":"3040ce82","821":"223c5792"}[chunkId] + ".chunk.css";
};